import { Component, NgZone, OnInit } from '@angular/core';
import { AdminService } from 'src/app/services/admin.service';
import { PlansService } from 'src/app/services/plans.service';
import { WindowRefService } from 'src/app/services/window-ref.service';
import { ActivatedRoute, Router } from "@angular/router";
import { VendorService } from 'src/app/services/vendor.service';
import { PaymentService } from 'src/app/services/payment.service';
import { AuthService } from 'src/app/services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { VendorLoginDialogComponent } from 'src/app/vendor/vendor-login-dialog/vendor-login-dialog.component';
import { UtilsDataService } from 'src/app/services/utils-data.service';
import { TemplateRef, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'app-validate-payments',
  templateUrl: './validate-payments.component.html',
  styleUrl: './validate-payments.component.scss'
})
export class ValidatePaymentsComponent {
  @ViewChild('confirmationDialog') confirmationDialog!: TemplateRef<any>;

  currentDate: string;
  rowDetails: any = {}; // Variable to hold plan details
  vendorData: any;
  paymentData: any;
  gstTotal: number = 0;
  totalPlanPrice: number = 0;
  discountedAmount: number = 0;
  isLoggedIn: boolean = false;
  vendorId: any;
  companyObject: any = {};
  paymentFailedStatus: boolean = false;
  paymentFailedMsg: any = "";
  orderId = '';
  userData: any = {}
  private unsubscribe$ = new Subject<void>();

  constructor(
    private adminService: AdminService,
    private plansService: PlansService,
    private paymentService: PaymentService,
    private winRef: WindowRefService,
    private router: Router,
    private vendorService: VendorService,
    private dialog: MatDialog,
    private authService: AuthService,
    private utilsDataService: UtilsDataService,
    private zone: NgZone,
    private route: ActivatedRoute




  ) {
    this.vendorService.vendorIdSubject$.subscribe(obj => {
      this.vendorData = obj;
      console.log("ggggg", obj);

    });
    this.paymentService.razorPay$.subscribe(obj => {
      this.paymentData = obj;
      console.log("hhhhh", obj);
    });


    this.route.paramMap.subscribe(params => {
      this.getTransactiondata(params.get('k'))
      // Access the 'id' from the route
    });
    // this.route.url.subscribe(segments => {
    //   console.log('URL Segments:', segments);
    //   segments.forEach(segment => {
    //     console.log(segment[1].path); // Extracts each segment
    //   });
    // });

  }


  ngOnInit(): void {

    this.currentDate = new Date().toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });


  }

  calculateTotalPlanPrice() {
    const planPrice = parseInt(this.rowDetails.plan_price) || 0;
    const discountType = this.rowDetails.discount_type;
    const discountValue = parseInt(this.rowDetails.offer_discount_percentage) || 0;
    const sgstValue = parseFloat(this.rowDetails.sgst) || 0;
    const cgstValue = parseFloat(this.rowDetails.cgst) || 0;
    const igstValue = parseFloat(this.rowDetails.igst) || 0;
    const cessValue = parseFloat(this.rowDetails.cess) || 0;

    this.gstTotal = sgstValue + cgstValue + igstValue + cessValue;

    let discount = 0;
    if (discountType === 'P') {
      discount = (planPrice * discountValue) / 100;
    } else if (discountType === 'F') {
      discount = discountValue;
    }

    this.discountedAmount = discount;

    const remainingPrice = planPrice - discount;
    const gstAmount = remainingPrice * (this.gstTotal / 100);
    this.totalPlanPrice = remainingPrice + gstAmount;

    // this.isLoggedIn = this.authService.isLoggedIn();
    this.totalPlanPrice = parseFloat(this.totalPlanPrice.toFixed(2));
  }

  getTransactiondata(uniq_key: any) {

    let reqObj = {
      "k": uniq_key
    }

    this.vendorService.getTransactiondata(reqObj).subscribe((resp: any) => {
      console.log("Rec payment", resp);

      if (resp.statusCode == 200) {
        this.rowDetails = resp.data.planDetails
        this.userData = resp.data.userDetails
      }
    });
  }


  payNow() {
    if (this.rowDetails.plan_type === 'F') {
      this.freePusrchaseOrder();
    }
    else {
      this.planInitiateOrder();
    }
  }



  planInitiateOrder() {
    this.paymentFailedStatus = false;



    let reqObj = {
      "amount": parseFloat(this.rowDetails.total_payable),
      "currency": "INR",
      "vendor_id": this.vendorData.id,
      "plan_id": this.rowDetails.id,
      "buyer_type": "VDR",
      "module_name": this.rowDetails.module_name,
      "role": this.userData.role,
      "uuid": this.userData.uuid
    }

    this.vendorService.planInitiateOrder(reqObj).pipe(
      takeUntil(this.unsubscribe$)  // The request will terminate if unsubscribe$ emits a value
    ).subscribe((resp: any) => {
      console.log("Rec payment", resp);

      if (resp.statusCode == 200) {
        // this.paymentService.setrazorPaySubject(resp.data)
        this.payWithRazor(resp.data.order_id, "rzp_live_mX3w8t1Xhx5fa1");
        this.orderId = resp.data.order_id;
        console.log("mmmmmm ", resp.data.order_id);
      }
    });
  }

  payWithRazor(val: any, key: any) {

    let amount = (parseInt(this.rowDetails.plan_price) * 100);
    const options: any = {
      key: key,
      amount: amount, // amount should be in paise format to display Rs 1255 without decimal point
      currency: 'INR',
      name: this.rowDetails.packageName, // company name or product name
      description: this.rowDetails.plan_description,  // product description
      image: 'assets/images/logos/final-logo.png', // company logo or product image
      order_id: val, // order_id created by you in backend
      modal: {
        // We should prevent closing of the form when esc key is pressed.
        escape: false,
      },
      notes: {
        // include notes if any
      },
      theme: {
        color: '#BF0000'
      }
    };
    options.handler = ((response: any, error: any) => {
      options.response = response;

      console.log("response RAZORPAY::", response);
      console.log("RAZORPAY OPTIONS::", options);
      // pur_emp_type: CM/CN
      //pur_pac_type :JP/DB
      // packageData={packageName:"",amount:'',jobs:'',validity:'',description:''}
      // createPurchageOrder(){
      let purchaseObj = {
        plan_id: this.rowDetails.id,
        vendor_id: this.vendorData.id,
        razorpay_order_id: options.order_id,
        razorpay_payment_id: response.razorpay_payment_id
      }

      this.paymentService.paymentDetails = { order_id: options.razorpay_order_id, razorpay_payment_id: response.razorpay_payment_id }
      this.vendorService.createPlanPurchaseOrder(purchaseObj).subscribe((resp: any) => {
        if (resp.statusCode == 200) {
          //           // this.errorStatus =true;
          //           // this.errorMsg = resp.supportMessage;
          //           // this.snackBarSimpleComponent.openSnackBar(resp.supportMessage,"close","center","top",3);
          this.router.navigate(["pages/payment-success"])
        }
      })
      // }
      // console.log("purchaseObj:::",purchaseObj);
      // this.router.navigate(['payment-success'])
      // call your backend api to verify payment signature & capture transaction
    });
    options.modal.ondismiss = (() => {
      // handle the case when user closes the form while transaction is in progress
      console.log('Transaction cancelled self.');
      // // alert("sssss");
      // // let paymentFailedStatus=true;
      // let paymentFailedMsg = `Don't worry, transaction failed. If you are amount debited, please connect with administrator with your order Id:<strong> ${this.orderId}</strong>`;
      // // console.log("===STS==",this.paymentFailedStatus,this.paymentFailedMsg)
      // this.paymentService.setPaymentFailed({paymentFailedStatus:true, paymentFailedMsg:paymentFailedMsg});
      this.zone.run(() => {
        console.log('Transaction cancelled self.');
        this.paymentFailedStatus = true
        this.paymentFailedMsg = `OOOOPS!!! Your transaction failed. If your amount is debited from your account, please connect with  Customer Support with your order Id: <strong>${this.orderId}</strong>`;

        // this.paymentService.setPaymentFailed({ paymentFailedStatus: true, paymentFailedMsg: paymentFailedMsg });
      });
    });
    const rzp = new this.winRef.nativeWindow.Razorpay(options);
    rzp.open();
  }


  goTo(link: any) {
    this.router.navigate([link]);
  }
  freePusrchaseOrder() {

    let reqObj = {
      id: this.rowDetails.id
    }

    this.vendorService.freePusrchaseOrder(reqObj).subscribe((resp: any) => {
      console.log('Rec State Created success', resp);

      if (resp.statusCode == 200) {
        this.router.navigate(["pages/payment-success"])

      }

    });


  }


}